export const APP_ID_UC = 'TOPUP-UI';
export const APP_ID_LC = 'recharging-app';
export type APP_ID = 'TOPUP-UI';
